
















































import { ReplaceParticipantModel, ParticipantModel } from '@/core/models';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { WorkshopService, CompanyService } from '@/core/services';
import { InputFieldCpt, BaseFormComponent, SubmitButtonCpt } from '@/core/components/form';
import { ConfirmDialogCpt } from '@/core/components';

@Component({
  components: {
    InputFieldCpt,
    SubmitButtonCpt,
    ConfirmDialogCpt,
  },
})
export default class WorkshopClientReplaceParticipantFormCpt extends BaseFormComponent {
  @Prop() currentParticipantModel: ParticipantModel;
  loading = false;
  replacementMessage = '';
  replacementTitle = 'Please confirm you wish to replace this Participant.';
  @Prop({ default: new ReplaceParticipantModel() }) model: ReplaceParticipantModel;

  submitInProgress = false;
  showReplaceDialog = false;
  isSubmitButtonDisabled = false;

  async onSubmitForm() {
    if (this.currentParticipantModel.fullName) {
      this.replacementMessage = `<p>This will delete all informations on <b>${this.currentParticipantModel.fullName} </b> from the system and add details for <b>${this.model.fullname}</b>.</p>Are you sure you want to proceed?`;
    } else {
      this.replacementTitle = 'Please confirm you wish to add this Participant.';
      this.replacementMessage = `<p>This will add details for <b>${this.model.fullname}</b>.</p>Are you sure you want to proceed?`;
    }
    this.showReplaceDialog = true;
  }
  private async closeConfirm(result: boolean) {
    this.showReplaceDialog = false;
    this.loading = true;
    try {
      if (result === true) {
        await WorkshopService.postWorkshopClientAttendeeReplacement(this.model);
        this.notify('Success', 'Attendee successfully replaced', 'success');
        super.onSuccess(`/admin/workshops/${this.model.workshopId}/client/${this.model.companyId}/edit`);
      }
    } catch (err) {
      this.notify('Error', 'Something went wrong while replacing an attendee', 'error');
    } finally {
      this.loading = false;
    }
  }
}
